import {
  DEPARTMENT_FIELD_FILTER_REQUEST,
  DEPARTMENT_FIELD_FILTER_REQUEST_SUCCESS,
  DEPARTMENT_FIELD_FILTER_REQUEST_FAILURE,
  DEPARTMENT_FIELD_FILTER_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: true,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const departmentFilterFieldsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case DEPARTMENT_FIELD_FILTER_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case DEPARTMENT_FIELD_FILTER_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case DEPARTMENT_FIELD_FILTER_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case DEPARTMENT_FIELD_FILTER_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default departmentFilterFieldsReducer;
